import { Col, Form, Input, } from "antd";
import { FC } from "react";
import { PatternFormat } from "react-number-format";

interface GeneralPhoneNumberProps {
  name: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  label?: string;
  rules?: any;
  className?: string;
   inputClassName?:string;
 
   getInstallmentList?:any
}

const GeneralPaymentInput: FC<GeneralPhoneNumberProps> = (props) => {
  const validatePhoneNumber = (_: any, value: string) => {
    let chs = value?value.replace(/-/g, "").replace(/_/g, ""):null
    if(chs&&chs.length===6)
    {
    
       props.getInstallmentList(chs)
    }
    if (value && value.includes("_")&& !value.includes("____-____-____-____")) {

      return Promise.reject(new Error("kart numaranin formati geçersiz"));
    }
    
    return Promise.resolve();
  };

  return (
    <Col xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
      <Form.Item
        className={props.className}
        label={props.label}
        name={props.name}
        rules={[...(props.rules || []), { validator: validatePhoneNumber }]} // Add custom validator to rules
      >
        <PatternFormat
          format="####-####-####-####"
          allowEmptyFormatting
          mask="_"
          className={`rounded !w-full ${props.inputClassName}`}
          customInput={Input}
          required={true}
          
        
         
        />
      </Form.Item>
    </Col>
  );
};

export default GeneralPaymentInput;
